// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdditionalComment_wrapper__P8fAV"};